import {useQuerySearchSanctions} from "src/services/queries/useQuerySanctions";
import {Box, Chip, Container, Stack, styled, TextField} from "@mui/material";
import FlagCountry from "src/components/common/FlagCountry";
import {getCountryByCountryCode} from "src/utils/helpers/stringHelpers";
import dayjs from "dayjs";
import {FORMAT_DATE_TIME} from "src/utils/constants/config";
import {useFormik} from "formik";
import FormikForm from "src/components/common/FormikForm";
import {get} from "lodash";
import ButtonWithLoading from "src/components/common/ButtonWithLoading";
import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useQueryParams} from "src/hooks/useQueryParam";
import {AuthRouteKeys} from "src/utils/constants/routes";
import {handleQueryParamFromObject} from "src/utils/helpers/queryParam";
import {SANCTION_TOPICS} from "src/utils/constants/sanctions";
import BreadcrumbWithBtnBack from "src/components/BreadcrumbWithBtnBack";

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  width: '45%',
  padding: theme.spacing(1.5),
  cursor: 'pointer',
  borderRadius: theme.shape.borderRadius * 2,
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));
const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(7),
  marginTop: 8,
}));

const Sanctions = () => {
  const params = useQueryParams();
  const navigate = useNavigate();
  const resp = useQuerySearchSanctions({
    q: params.q,
    schema: params.schema
  })

  const formik = useFormik({
    initialValues: {
      keyword: params.q
    },
    onSubmit: (value) => {
      const queryParams = {
        ...params,
        q: value.keyword,
        limit: 200,
        offset: 0,
      };
      navigate({ pathname: AuthRouteKeys.Sanctions, search: handleQueryParamFromObject(queryParams) });
    }
  })

  return <StyledContainer>
    <BreadcrumbWithBtnBack
      listItem={
        [
          {
            text: 'Sanctions',
          },
        ]
      }
    />
    <Stack flexDirection={'column'} mt={2} gap={4}>
      <FormikForm formik={formik}>
        <Stack flexDirection={'row'} gap={2} flex={1}>
          <TextField
            sx={{
              width: '70%'
            }}
            id="keyword"
            name="keyword"
            value={get(formik.values, 'keyword', '')}
            size="small"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Search"
          />
          <ButtonWithLoading sx={{ height: 40 }} size="large" variant="contained" isRounded type="submit">
            Search Now
          </ButtonWithLoading>
        </Stack>
      </FormikForm>
      {!resp.isFetching ? <Stack flexDirection={'row'} gap={3} flexWrap={'wrap'}>
          {resp.data?.data?.results.map((item: any) => {
            const country = item?.properties?.country?.[0] ?? '';
            const date = item?.properties?.birthDate?.[0] || item?.properties?.incorporationDate?.[0];
            const id = item?.id || '';
            return (
              <StyledBox
                key={item.id}
                onClick={() => {
                  navigate(AuthRouteKeys.SanctionDetail.replace(':id', id))
                }}
              >
                <Stack gap={1}>
                  <Chip
                    key={item.schema}
                    label={item.schema}
                    size="small"
                    clickable={false}
                    sx={{width: 'fit-content'}}
                  />
                  <Box sx={{fontWeight: 'bold'}}>{item.caption}</Box>
                  <Box>{date}</Box>
                  <Stack flexDirection={'row'} gap={1}>
                    <FlagCountry
                      width={16}
                      code={country}
                    />
                    <Box>{getCountryByCountryCode(country)?.label}</Box>
                  </Stack>
                  <Stack flexDirection={'row'} gap={1} width={'fit-content'}>
                    {item.properties?.topics?.map((topic: string) => {
                      return <Chip
                        key={topic}
                        color="secondary"
                        label={SANCTION_TOPICS[topic] || topic}
                        size="small"
                        clickable={false}
                        // sx={{
                        //   '&:hover': {
                        //     color: theme.palette.secondary.main,
                        //     backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                        //   },
                        // }}
                      />
                    })}
                  </Stack>

                  {/*<Box>{}</Box>*/}
                </Stack>
              </StyledBox>
            )
          })}
    </Stack> : <Stack>Loading...</Stack>}
    </Stack>
  </StyledContainer>
}

export default Sanctions;
